<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<div [hidden]="hideTemplate">
  <mat-form-field class="lf-field lf-template-picker lf-dropdown">
    <ng-template #showDefaultEmptyTemplate>
      <mat-label class="lf-dropdown-label">
        {{ emptyTemplateName | async }}
      </mat-label>
    </ng-template>
    <mat-select
      panelClass="lf-dropdown-overlay"
      [placeholder]="(emptyTemplateName | async) ?? ''"
      name="template-dropdown"
      id="template-dropdown"
      class="lf-dropdown"
      (selectionChange)="onTemplateChangedAsync($event)"
      (openedChange)="onToggleDropdownAsync($event)"
      [(value)]="templateSelected"
      [compareWith]="compareTemplateInfoFunc"
    >
      @if (isDropdownDefault) {
        <mat-option selected>{{ emptyTemplateName | async }}</mat-option>
      }
      @if (isDropdownError) {
        <mat-option selected class="dropdown-error-message">{{ AN_ERROR_OCCURED | async }}</mat-option>
      }
      @if (isDropdownDefault) {
        <div>
          @for (template of availableTemplates; track template) {
            <mat-option [value]="template">{{ template.displayName }} </mat-option>
          }
        </div>
      }
    </mat-select>
  </mat-form-field>
  @if (isTemplateLoading) {
    <lfint-loader-component></lfint-loader-component>
  } @else {
    @if (isTemplateError) {
      <div class="error-message">{{ templateErrorMessage | async }}</div>
    } @else {
      @if (isTemplateDisplay) {
        <div class="responsive-form-container">
          <ng-template lfFieldView></ng-template>
        </div>
      } @else {}
    }
  }
</div>
